import { graphql } from "gql";

const JOB_QUERY = graphql(`
  query Job($id: ID!) {
    job(id: $id) {
      ...Job
    }
  }
`);

export default JOB_QUERY;
